import { Box, Checkbox, FormControlLabel, FormGroup, Grid, TextField, Typography } from '@mui/material'
import { t } from 'i18next'
import Joi from 'joi'
import { useState } from 'react'

import useFieldValidation from '../../../../helpers/fieldValidation'
import { useValidationEffect } from '../../../../helpers/hooks'

const schema = Joi.object({
  name: Joi.string().empty(undefined).required(),
  emailsToNotify: Joi.string().empty(undefined).required()
})

const ConfigureActionNotification = ({
  notificationConfig,
  actionName,
  onChangeIsValid,
  onNameChange,
  onNotificationConfigChange
}) => {
  const [name, setName] = useState()
  const [emailsToNotify, setEmailsToNotify] = useState()
  const [validation, setValidation] = useState({ isValid: false })

  const handleNameChange = (event) => setName(event.target.value)

  const handleNotifyAdmin = (event) =>
    onNotificationConfigChange({
      ...notificationConfig,
      notifyAdmin: event.target.checked
    })

  const handleNotifyEditor = (event) =>
    onNotificationConfigChange({
      ...notificationConfig,
      notifyEditor: event.target.checked
    })

  const handleNotifyViewer = (event) =>
    onNotificationConfigChange({
      ...notificationConfig,
      notifyViewer: event.target.checked
    })

  const handleChangeEmails = (event) => setEmailsToNotify(event.target.value)

  useValidationEffect(() => {
    const fieldValidation = useFieldValidation({
      name,
      emailsToNotify
    }, schema)
    setValidation(fieldValidation)
    onChangeIsValid(fieldValidation.isValid)
    onNameChange(name)
    onNotificationConfigChange({
      ...notificationConfig,
      emailsToNotify: emailsToNotify
        ? emailsToNotify.split(',').map((x) => x.trim())
        : emailsToNotify
    })
  }, [name, emailsToNotify])

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid
        container
        marginBottom={5}
        spacing={2}
      >
        <Grid size={6}>
          <TextField
            id="configure-action-name"
            variant="standard"
            label={t('actions.actionName')}
            fullWidth
            value={actionName}
            onChange={handleNameChange}
            error={validation.messages?.name?.length > 0}
            helperText={validation.messages?.name?.join(', ')}
          />
        </Grid>
        <Grid size={6}>
          <TextField
            id="configure-action-email-to-notify"
            variant="standard"
            label={t('actions.emailsToNotify')}
            value={notificationConfig.emailsToNotify}
            onChange={handleChangeEmails}
            fullWidth
            error={validation.messages?.emailsToNotify?.length > 0}
            helperText={validation.messages?.emailsToNotify?.join(', ')}
          />
        </Grid>

        <Grid
          size={12}
          pt={3}
        >
          <Typography
            variant="h5"
            align="center"
          >
            {t('actions.notificationChoices')}
          </Typography>
        </Grid>
        <Grid
          size={12}
          display="flex"
          justifyContent="center"
        >
          <FormGroup row>
            <FormControlLabel
              control={
                <Checkbox
                  checked={notificationConfig.notifyAdmin}
                  value={true}
                  onClick={handleNotifyAdmin}
                />
              }
              label={t('actions.notifyAdmin')}
            />

            <FormControlLabel
              control={
                <Checkbox
                  value={true}
                  checked={notificationConfig.notifyEditor}
                  onClick={handleNotifyEditor}
                />
              }
              label={t('actions.notifyEditor')}
            />

            <FormControlLabel
              control={
                <Checkbox
                  value={true}
                  checked={notificationConfig.notifyViewer}
                  onClick={handleNotifyViewer}
                />
              }
              label={t('actions.notifyViewer')}
            />
          </FormGroup>
        </Grid>
      </Grid>
    </Box>
  )
}

export default ConfigureActionNotification
